// ============================================================
// Fish API TTS (commented out — using browser SpeechSynthesis instead)
// ============================================================
// const FISH_API_KEY = 0; //process.env.REACT_APP_FISH_API_KEY;
//
// export const FISH_VOICES = [
//   "802e3bc2b27e49c2995d23ef70e6ac89", // Energetic Male
//   "bf322df2096a46f18c579d0baa36f41d", // Adrian
//   "536d3a5e000945adb7038665781a4aca", // Ethan
//   "ef9c79b62ef34530bf452c0e50e3c260", // Horror (deep creepy)
//   "fd176117735446968cca7911ee4da42b", // DEEP STORY
//   "d13f84b987ad4f22b56d2b47f4eb838e", // Mortal Kombat announcer
//   "90e65eaaf50e4470b8e6d43ee6afd7d5", // Super Smash Bros announcer
//   "48484faae07e4cfdb8064da770ee461e", // Sonic The Hedgehog
//   "6c8645b95abb44e0b9095ae3b241e4cc", // Goku
//   "fad5a5a6770e47019f566b8f8c0ff609", // Real Joker
//   "400b2a2c4aa44afc87b6d14adf0dd13c", // CHOSEN (cinematic)
//   "d8a1340984ee4b63ad1ffae27a6a4339", // ELITE sports commentator
//   "5196af35f6ff4a0dbf541793fc9f2157", // Trump impression
//   "03397b4c4be74759b72533b663fbd001", // Elon Musk impression
//   "de691fb22a0d47a0a28f7ee9dc736341", // DJ SMOKEY
//   "79d0bd3e4e5444b18f7b6d89b5927bf1", // Jordan (motivational)
//   "0b74ead073f2474a904f69033535b98e", // CALM-NORMAL
//   "0cd6cf9684dd4cc9882fbc98957c9b1d", // The Elephant (dramatic)
// ];
//
// export const audioCache = {};
// const fetchQueue = [];
// let isFetching = false;
//
// export function enqueueFetch(cacheKey, text, voiceId) {
//   if (audioCache[cacheKey]) return Promise.resolve(audioCache[cacheKey]);
//   return new Promise((resolve) => {
//     fetchQueue.push({ cacheKey, text, voiceId, resolve });
//     processQueue();
//   });
// }
//
// async function processQueue() {
//   if (isFetching || fetchQueue.length === 0) return;
//   isFetching = true;
//   const { cacheKey, text, voiceId, resolve } = fetchQueue.shift();
//   if (audioCache[cacheKey]) {
//     resolve(audioCache[cacheKey]);
//     isFetching = false;
//     processQueue();
//     return;
//   }
//   try {
//     const res = await fetch("/api/fish/v1/tts", {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${FISH_API_KEY}`,
//         "Content-Type": "application/json",
//         model: "s2",
//       },
//       body: JSON.stringify({ text, reference_id: voiceId, format: "mp3" }),
//     });
//     if (res.ok) {
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       audioCache[cacheKey] = url;
//       resolve(url);
//     } else {
//       resolve(null);
//     }
//   } catch {
//     resolve(null);
//   }
//   isFetching = false;
//   processQueue();
// }
//
// export function playFromCache(cacheKey) {
//   const url = audioCache[cacheKey];
//   if (!url) return null;
//   const audio = new Audio(url);
//   audio.play().catch(() => {});
//   return audio;
// }

// ============================================================
// Browser SpeechSynthesis TTS
// ============================================================
let cachedVoices = [];
let speechUnlocked = false;

if (window.speechSynthesis) {
  cachedVoices = window.speechSynthesis.getVoices();
  window.speechSynthesis.addEventListener("voiceschanged", () => {
    cachedVoices = window.speechSynthesis.getVoices();
  });

  // Unlock speech synthesis on first user interaction
  const unlock = () => {
    if (speechUnlocked) return;
    speechUnlocked = true;
    const dummy = new SpeechSynthesisUtterance(".");
    dummy.volume = 0.01;
    dummy.rate = 10;
    window.speechSynthesis.speak(dummy);
    console.log("[TTS] Unlocked via user gesture");
    document.removeEventListener("click", unlock);
    document.removeEventListener("keydown", unlock);
    document.removeEventListener("touchstart", unlock);
  };
  document.addEventListener("click", unlock);
  document.addEventListener("keydown", unlock);
  document.addEventListener("touchstart", unlock);
}

// Keep a reference to prevent Chrome GC bug
let currentUtterance = null; // eslint-disable-line no-unused-vars
let resumeTimer = null;

export function speakText(text, founderId, onStart, onEnd) {
  if (!window.speechSynthesis) { onEnd?.(); return; }

  // Cancel previous speech without triggering error on new utterance
  cancelSpeech();

  const voices = cachedVoices.length ? cachedVoices : window.speechSynthesis.getVoices();
  const englishVoices = voices.filter(v => v.lang.startsWith("en"));

  const utterance = new SpeechSynthesisUtterance(text);
  if (englishVoices.length > 0) {
    utterance.voice = englishVoices[founderId % englishVoices.length];
  }
  utterance.rate = 1.0 + (founderId % 5) * 0.05;
  utterance.pitch = 0.7 + (founderId % 7) * 0.1;
  utterance.volume = 1;

  // Store reference to prevent garbage collection (Chrome bug)
  currentUtterance = utterance;

  utterance.onstart = () => onStart?.();
  utterance.onend = () => { clearInterval(resumeTimer); onEnd?.(); };
  utterance.onerror = (e) => {
    // Ignore "canceled" errors from our own cancel calls
    if (e.error === "canceled") return;
    clearInterval(resumeTimer);
    onEnd?.();
  };

  window.speechSynthesis.speak(utterance);

  // Chrome pauses long utterances — keep poking it
  resumeTimer = setInterval(() => {
    if (!window.speechSynthesis.speaking) {
      clearInterval(resumeTimer);
    } else {
      window.speechSynthesis.pause();
      window.speechSynthesis.resume();
    }
  }, 5000);
}

export function cancelSpeech() {
  clearInterval(resumeTimer);
  window.speechSynthesis?.cancel();
  currentUtterance = null;
}
